import { GeographicalAgencyType } from "@/codegen/openapi2";

export const GeographicalAgencyTypeOptions = {
  coreAgency: { label: "Coeur Zone", color: "green" },
  closeCoreAgency: { label: "Proche Zone", color: "blue" },
  nonCoreAgency: { label: "Hors zone", color: "red" },
} as const;
export type GeographicalAgencyTypeOptionsType = keyof typeof GeographicalAgencyTypeOptions;

// The API names the zone type with an enum, the tags with the keys above.
export const GeographicalAgencyTypeOptionByType: Record<
  GeographicalAgencyType,
  GeographicalAgencyTypeOptionsType
> = {
  core_agency: "coreAgency",
  close_core_agency: "closeCoreAgency",
  non_core_agency: "nonCoreAgency",
};
